import React from "react";
import RevealAnimation from "../RevealAnimation";
import "./whyChooseVC2Section.scss";
import { FiUser, FiBriefcase, FiCheck } from "react-icons/fi";
import FoundersImg from "../../assets/Images/Hire Remote team/Scale your team for new and existing projects.svg";
import InvestorsImg from "../../assets/Images/Hire Remote team/Investor.svg";

const WhyChooseVC2Section = () => {
  const founderBenefits = [
    "Day-one engineering organisation",
    "No hiring delays",
    "Reduced risk",
    "Build real, marketable products",
    "Faster funding readiness",
    "Strategy + execution in one place",
  ];

  const investorBenefits = [
    "De-risked technology",
    "Better architecture",
    "Stronger market validation",
    "Faster time to revenue",
    "TRL transparency",
    "Higher probability of success",
  ];

  return (
    <section className="why-choose-vc2-section" id="why-choose-vc2">
      <div className="body-container">
        <RevealAnimation>
          <div className="section-header">
            <h2>Why Founders & Investors Choose VC 2.0</h2>
            <p className="subtitle">
              A unified platform that aligns incentives and accelerates growth.
            </p>
          </div>
        </RevealAnimation>

        <div className="features-wrapper">
          {/* Founders Row */}
          <RevealAnimation delay={0.1}>
            <div className="feature-row">
              <div className="content-side">
                <div className="label-badge founders">For Founders</div>
                <h3>Build Fast, Risk Less.</h3>
                <p className="intro-text">
                  Get a day-one engineering organization without the hiring
                  headaches. Focus on strategy while we handle execution.
                </p>
                <ul className="benefits-grid">
                  {founderBenefits.map((benefit, index) => (
                    <li key={index}>
                      <div className="check-icon">
                        <FiCheck />
                      </div>
                      <span>{benefit}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="image-side">
                <div className="image-container">
                  <img src={FoundersImg} alt="For Founders" />
                </div>
              </div>
            </div>
          </RevealAnimation>

          {/* Investors Row */}
          <RevealAnimation delay={0.2}>
            <div className="feature-row reverse">
              <div className="content-side">
                <div className="label-badge investors">For Investors</div>
                <h3>De-Risked Investments.</h3>
                <p className="intro-text">
                  Ensure your portfolio companies have the technical foundation
                  to scale. Transparency and execution you can trust.
                </p>
                <ul className="benefits-grid">
                  {investorBenefits.map((benefit, index) => (
                    <li key={index}>
                      <div className="check-icon">
                        <FiCheck />
                      </div>
                      <span>{benefit}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="image-side">
                <div className="image-container">
                  <img src={InvestorsImg} alt="For Investors" />
                </div>
              </div>
            </div>
          </RevealAnimation>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseVC2Section;
